import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useQueryGraves from '../../../database/filters/queriesGrave';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { fixNullValues, mapFieldValues, onClickRow } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import useFilteredData from '../../template/tableV2/FilterFunction';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const CemeteryHome = () => {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsTableCemeteries.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { getSummaryByCemetery } = useQueryGraves();

  const [loading, setLoading] = useState(true); // מצב טעינה

  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    // setTotalWidthContainer(1400);

    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([{ id: 0, name: `חיפוש כללי`, icon: <SearchIcon fontSize="small" />, url: '/globalSearch' }]);
      setTitle(`חיפוש כללי`);
    } else {
      setBreadcrumbs([{ id: 0, name: `בתי עלמין`, icon: <HomeIcon fontSize="small" />, url: '/cemetery' }]);
      setTitle(`בתי עלמין`);
    }
  }, [location.pathname]);

  // שימוש בפונקציה החיצונית לסינון הנתונים
  const filteredData = useFilteredData(context?.contextCemeteries, searchText);

  const handleRowClick = (row) => {
    console.log(row);

    if (location.pathname.endsWith('globalSearch')) {
      navigate('/cemetery'); // משנה את הניווט לנתיב '/cemetery'
    }

    // לאחר מכן מפעיל את הפונקציה onClickRow עם הניווט המקורי
    onClickRow(row, getSummaryByCemetery, navigate);
  };

  const onPageChange = (item) => {
    console.log(item);
  };

  const onRowsPerPageChange = (item) => {
    console.log(item);
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        if (dataCemeteries) {
          setLoading(false);
        }
      }

      fetchDataServer(['cemeteries'], token);
    }
    loadTableData();
  }, []);

  return (
    <>
      {loading && <p>Loading...</p>}
      <PaymentsManagementExample
        columns={columns.filter((prop) => prop.show)} // העמודות של הטבלה
        defaultRows={fixNullValues(filteredData)} // הערכים של הטבלה
        searchText={filteredData} // מחרוזת לחיפוש ערכים בטבלה
        onRowSelect={handleRowClick} // כפתור לחיצה על רשומה
        currentPage={1} // עמוד נוכחי
        rowsPerPage={25} // כמות רשומות לעמוד
        onPageChange={onPageChange} // בעת שינוי דף
        onRowsPerPageChange={onRowsPerPageChange} // בעת שינוי כמות לדף
      />
    </>
  );
};

export default CemeteryHome;
